import * as _ from "lodash";
import * as Models from "../Models";
import moment from "moment";
import {
  CUSTOMERS_TREE,
  PRODUCTS_TREE,
  SITE_TREE,
  BUILDS_TREE,
  SITE_WITH_PARENTS,
  TYPE_SITE,
} from "../Constants";
import axios from "./";
import { AxiosResponse, AxiosError } from "axios";
import { v4 as uuidv4 } from "uuid";
import { useMutation, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { UserModel } from "../Models/ApplicationModels";
import useSearchStore from "../Store/search";
import { toast } from "react-toastify";
import { userStore } from "../Store/userStore";

declare var window: any;

declare global {
  interface Navigator {
    msSaveOrOpenBlob: (blobOrBase64: Blob | string, filename: string) => void;
  }
}

// export async function getSettings(dispatch: Dispatch<any>): Promise<any> {
//   try {
//     const response: AxiosResponse = await axios.get(`/api/settings`);
//     const settings: Models.AppSettings = response.data;
//     console.log("settings...........", settings);
//     return settings;
//   } catch (e) {
//     const error: Models.ApplicationError = {
//       type: Models.ErrorTypes.External,
//       id: uuidv4(),
//       error: e.response ? e.response : e,
//       message: "Could not fetch appSettings",
//     };
//     dispatch(ErrorActions.addError(error));
//   }
// }
//unused api call
// export async function getAttributeMap(dispatch: Dispatch<any>): Promise<any> {
//   try {
//     const response: AxiosResponse = await axios.get(
//       `/api/settings/attributeMap`
//     );
//     const attributes: Models.AttributeMetadata[] = response.data;
//     return attributes;
//   } catch (e) {
//     const error: Models.ApplicationError = {
//       type: Models.ErrorTypes.External,
//       id: uuidv4(),
//       error: e.response ? e.response : e,
//       message: "Could not fetch attribute map",
//     };
//     dispatch(ErrorActions.addError(error));
//   }
// }

export async function searchTree(
  userInput: string,
  suggestionFilter: string,
  params: Models.UrlParams,
  silent: boolean,
  isModalSearchMode?: boolean
): Promise<any> {
  // return async (dispatch, getState) => {
  // let searchResults: Models.SearchResults;
  // let searchIds: string[];

  try {
    // const state: Models.StateRoot = getState();
    const searchTerm: string =
      userInput.indexOf("-") !== -1 || userInput.indexOf("/") !== -1
        ? `"${userInput}"`
        : userInput;
    const encodedSearch: string = encodeURIComponent(searchTerm);
    const response: AxiosResponse = await axios.get(
      `/api/search/?id=${encodedSearch}`
    );
    return response;
    // if (response.status === 200) {
    //   searchResults = response.data;
    //   searchResults.sites = [...searchResults.locations];
    //   if (!searchResults.isCountrySearch) {
    //     searchResults.sites = [
    //       ...searchResults.sites,
    //       ...searchResults.builds,
    //     ];
    //   }
    //   await dispatch(
    //     SalesInfoActions.setIsCountrySearch(searchResults.isCountrySearch)
    //   );
    //   await dispatch(FilterActions.updateOrInsertDetails(searchResults));
    //   let allSearchResults: Models.DetailBaseData[] = _.flatten(
    //     _.filter(_.values(searchResults), (v: any) => _.isArray(v))
    //   );

    //   searchIds = _.map(
    //     allSearchResults,
    //     (result: Models.DetailBaseData) => result.id
    //   );

    //   const siteCount: number = _.filter(
    //     searchResults.sites,
    //     (l) => l.type === "Site"
    //   ).length;

    //   dispatch(FilterActions.insertSearchResultIds(searchIds));

    //   if (
    //     siteCount === 1 &&
    //     suggestionFilter === SITE_TREE &&
    //     !isModalSearchMode
    //   ) {
    //     dispatch(SalesInfoActions.toggleMobileSearch());
    //     const location: Models.DetailBaseData = _.find(
    //       searchResults.sites,
    //       (location) => location.type === TYPE_SITE
    //     );
    //     params.filter = "sites";
    //     params.parameter = location.id;
    //     params.itemType = location.type;
    //     if (!silent) {
    //       params.queryParams = { search: userInput };
    //     }
    //     if (!isModalSearchMode) {
    //       pushTo(params);
    //     }
    //     return undefined;
    //   } else if (
    //     _.uniqBy(searchResults.builds, (b) => b.id).length === 1 &&
    //     suggestionFilter === SITE_TREE &&
    //     !isModalSearchMode
    //   ) {
    //     dispatch(SalesInfoActions.toggleMobileSearch());
    //     const build: Models.DetailBaseData = searchResults.builds[0];
    //     params.filter = "sites";
    //     params.parameter = build.id;
    //     params.itemType = "build";
    //     params.queryParams = {};
    //     if (!isModalSearchMode) {
    //       pushTo(params);
    //     }
    //     return undefined;
    //   } else if (
    //     _.uniqBy(searchResults.customers, (b) => b.id).length === 1 &&
    //     suggestionFilter === CUSTOMERS_TREE &&
    //     !isModalSearchMode
    //   ) {
    //     dispatch(SalesInfoActions.toggleMobileSearch());
    //     const customer: Models.DetailBaseData = searchResults.customers[0];
    //     params.filter = "customers";
    //     params.parameter = customer.id;
    //     params.itemType = customer.type;
    //     params.queryParams = { search: userInput };
    //     if (!isModalSearchMode) {
    //       pushTo(params);
    //     }
    //     return undefined;
    //   } else {
    //     dispatch(SalesInfoActions.toggleMobileMenu());
    //   }
    // } else if (response.status === 204) {
    //   searchIds = [];
    //   dispatch(FilterActions.insertSearchResultIds(searchIds));
    // }
  } catch (e) {
    toast.error("Could not fetch search results");

    return undefined;
  }

  // return searchResults;
  // };
}
// UNUSED
// export function getModalItemDetail(id: string, dispatch: any): void {
//   const params: Models.UrlParams = {
//     filter: SITE_TREE,
//     parameter: id,
//     itemType: "",
//   };
//   dispatch(getItemDetail(params));
// }

// export function getDetail(url: string): any {
//   return async (
//     dispatch,
//     getState
//   ): Promise<Models.DetailBaseDataCollection | Models.DetailCollection> => {
//     try {
//       const state: Models.StateRoot = getState();
//       const appUrl: Models.IbUrl = Selectors.getUrl(state);
//       const response: AxiosResponse = await axios.get(url);
//       const result: Models.DetailBaseDataCollection | Models.DetailCollection =
//         response.data;

//       if ((result as Models.DetailBaseDataCollection).items !== undefined) {
//         dispatch(
//           FilterActions.insertTreeItems(
//             result as Models.DetailBaseDataCollection
//           )
//         );
//       } else {
//         const DetailCollection: Models.DetailCollection =
//           result as Models.DetailCollection;
//         await dispatch(FilterActions.updateOrInsertDetails(DetailCollection));
//         const site: Models.Detail = DetailCollection.sites[0];
//         const siteId: string = site && site.id;

//         if (
//           DetailCollection.type === SITE_TREE ||
//           DetailCollection.type === SITE_WITH_PARENTS
//         ) {
//           if (siteId) {
//             const dataGroup: Models.DataGroup = _.find(
//               site.dataGroups,
//               (dataGroup: Models.DataGroup) =>
//                 dataGroup.name.toLocaleLowerCase() === "documents"
//             );
//             if (dataGroup) {
//               const group: Models.AttributeGroup[] = _.filter(
//                 dataGroup.attributeGroups,
//                 (ag) => ag.rows.length > 0
//               );
//               const rows: Models.AttributeRow[] = _.flatten(
//                 _.map(group, (g) => g.rows)
//               );
//               const links: Models.Link[] = _.flatten(
//                 _.map(rows, (g) => g.items[1].url)
//               );

//               const documentLinks: Models.DocumentLink[] = links.map((l) =>
//                 linkToDocumentLink(l, siteId)
//               );
//               if (documentLinks.length > 0) {
//                 await dispatch(
//                   FilterActions.updateDocumentLinks(documentLinks)
//                 );
//                 dataGroup.attributeGroups[0].siteId = siteId;
//                 await dispatch(
//                   FilterActions.updateDocumentAttributeGroup([
//                     dataGroup.attributeGroups[0],
//                   ])
//                 );
//               }
//             }
//           }
//         }
//       }

//       return result;
//     } catch (e) {
//       let error: Models.ApplicationError = {
//         type: Models.ErrorTypes.External,
//         id: uuidv4(),
//         error: e.response ? e.response : e,
//         message: `Could not fetch detail data`,
//       };

//       if (e.response && e.response.status === 403) {
//         error.message = "This resource is not available.";
//       }

//       dispatch(ErrorActions.addError(error));
//     }
//   };
// }

// export function getFilterData(url: string): any {
//   return async (
//     dispatch,
//     getState
//   ): Promise<Models.DetailBaseDataCollection | Models.DetailCollection> => {
//     const results: any = await dispatch(getDetail(url));
//     return results;
//   };
// }

// export function getProductTypes(productTypeId: string): any {
//   return async (
//     dispatch,
//     getState
//   ):
//    Promise<Models.DetailBaseDataCollection | Models.DetailCollection> => {
//     const url: string = `/api/producttypes/${productTypeId}`;
//     return dispatch(getDetail(url));
//   };
// }

export function getProductTypes(productTypeId: string): string {
  return `/api/producttypes/${productTypeId}`;
}

export function getItemDetail(params: Models.UrlParams): any {
  // return async (
  //   dispatch,
  //   getState
  // ): Promise<Models.DetailBaseDataCollection | Models.DetailCollection> => {
  const { parameter, filter, itemType } = params;

  // const state: Models.StateRoot = getState();
  if (!parameter) {
    return undefined;
  }

  let url: string = "/api";

  if (filter === SITE_TREE) {
    if (itemType.toLocaleLowerCase() === "country") {
      url += `/countries/${parameter}`;
    } else {
      url += `/sites/${parameter}/details`;
    }
  }

  if (filter === CUSTOMERS_TREE) {
    if (itemType.toLocaleLowerCase() === "customers") {
      url += `/customers/${parameter}/details`;
    }
  }

  if (filter === PRODUCTS_TREE) {
    url += `/products/${parameter}/details`;
  }
  return url;
  // const results: any = await dispatch(getDetail(url));
  // return results;
  // };
}

/*
    Parent function returns root state (country or producttype) as well as all items including this state
*/
export async function getItemAndParents(
  params: Models.UrlParams,
  setDetails,
  updateDetails,
  updateProjectAssetAttributeGroups,
  updateDocumentAttributeGroup
): Promise<any> {
  // return async (dispatch, getState) => {
  try {
    const { parameter, filter, itemType } = params;

    // const state: Models.StateRoot = getState();
    let parent: Models.DetailBaseData;
    let responses: Models.DetailView[] = [];

    //CAN ADD THIS CHECK WHILE CALLING THIS FUNCTION ITSELF
    // if (
    //   state.filterItems.filterItemsById[parameter] &&
    //   state.filterItems.filterItemsById[parameter].type === "country"
    // ) {
    //   return;
    // }
    let response: AxiosResponse = null;

    if (itemType == "project") {
      response = await axios.get(
        `/api/Project/GetProjectDetails?projectId=${parameter}`
      );
    } else {
      response = await axios.get(`/api/${filter}/${parameter}/details/parents`);
    }

    const detailWithParents: Models.DetailParents = response.data;
    responses = responses
      .concat(detailWithParents.sites)
      .concat(detailWithParents.customers)
      .concat(detailWithParents.products);

    let details: Models.DetailView[] = [];
    let childItems: Models.DetailBaseData[] =
      detailWithParents.rootElement.items;

    _.forEach(responses, (response: Models.DetailView) => {
      details.push(response);
      childItems = childItems.concat(response.childItems || []);
    });
    setDetails({ type: filter, items: childItems });
    updateDetails(detailWithParents);
    // await dispatch(
    // FilterActions.insertTreeItems({ type: filter, items: childItems })
    // );
    // await dispatch(FilterActions.updateOrInsertDetails(detailWithParents));
    if (detailWithParents.type?.toLowerCase() === "projectdetails") {
      const projectDetails = _.find(
        detailWithParents?.sites,
        (s) => s.type?.toLowerCase() === "project"
      );
      const assetDataGroup: Models.DataGroup = _.find(
        projectDetails.dataGroups,
        (dataGroup: Models.DataGroup) => dataGroup?.dataGroupType === 5
      );
      if (
        assetDataGroup &&
        assetDataGroup.attributeGroups &&
        assetDataGroup.attributeGroups.length > 0
      ) {
        const assetAttributeGroups: Models.AttributeGroup[] =
          assetDataGroup.attributeGroups;

        // Safely access the first group
        const assetAttributeData: Models.AttributeGroup =
          assetAttributeGroups[0];

        // Update the siteId with the projectDetails project id
        assetAttributeData.siteId = projectDetails.id;

        // Dispatch action to update the state
        // await dispatch(
        //   FilterActions.UpdateAssetAttributeGroup([assetAttributeData])
        // );
        // filterItemsStore
        //   .getState()
        updateProjectAssetAttributeGroups([assetAttributeData]);
      }
    }
    if (detailWithParents.type === SITE_WITH_PARENTS) {
      // let documentLinks: Models.DocumentLink[] = [];
      _.forEach(detailWithParents.sites, (s) => {
        const dataGroup: Models.DataGroup = _.find(
          s.dataGroups,
          (dataGroup: Models.DataGroup) =>
            dataGroup.name.toLocaleLowerCase() === "documents"
        );
        if (dataGroup) {
          // const group: Models.AttributeGroup[] = _.filter(
          //   dataGroup.attributeGroups,
          //   (ag) => ag.rows.length > 0
          // );
          // const rows: Models.AttributeRow[] = _.flatten(
          //   _.map(group, (g) => g.rows)
          // );
          // const links: Models.Link[] = _.flatten(
          //   _.map(rows, (g) => g.items[1].url)
          // );

          // const newDocumentLinks: Models.DocumentLink[] = links.map((l) =>
          //   linkToDocumentLink(l, s.id)
          // );
          // documentLinks = documentLinks.concat(newDocumentLinks);
          dataGroup.attributeGroups[0].siteId = s.id;
          updateDocumentAttributeGroup([dataGroup.attributeGroups[0]]);
          // dispatch(
          //   FilterActions.updateDocumentAttributeGroup([
          //     dataGroup.attributeGroups[0],
          //   ])
          // );
        }
      });

      //   if (documentLinks.length > 0) {
      //     await dispatch(FilterActions.updateDocumentLinks(documentLinks));
      //   }
    }
    return responses;
  } catch (e) {
    toast.error("Could not fetch item and its parents");
    // Optionally log the error for debugging
    console.error(e, "error");
    if (e.response && e.response.status === 403) {
      // User has no access to details
      toast.error("This resource is not available.");
    }
  }
}
//used for document upload
// export function sendFileToDetail(
//   documentTarget: string,
//   formData: FormData
// ): Function {
//   return async (dispatch, getState): Promise<AxiosResponse> => {
//     let response: AxiosResponse;
//     try {
//       dispatch(AzureActions.uploadingDocuments(true));

//       response = await axios.post(`${documentTarget}`, formData);

//       dispatch(AzureActions.uploadingDocuments(false));
//     } catch (e) {
//       dispatch(AzureActions.uploadingDocuments(false));

//       const error: Models.ApplicationError = {
//         type: Models.ErrorTypes.External,
//         id: uuidv4(),
//         error: e.response ? e.response : e,
//         message: "Could not upload the file(s)",
//       };

//       dispatch(ErrorActions.addError(error));
//     }

//     return response;
//   };
// }

export function useSendFileToDetailMutation() {
  return useMutation({
    mutationFn: async ({
      documentTarget,
      formData,
    }: {
      documentTarget: string;
      formData: FormData;
    }): Promise<Models.DetailCollection> => {
      const { data } = await axios.post(`${documentTarget}`, formData);
      return data;
    },
  });
}

export function updateFileExportStatus(
  fileId: string,
  message: string,
  status: string,
  url?: string
): any {
  try {
    if (fileId) {
      let action: Models.FileExportActionPayload = {
        id: fileId,
        status: status,
        uri: url,
        message: message,
      };
      useSearchStore.getState().updateAdvancedSearchexportFile(action);
    }
  } catch (e) {
    toast.error("Could not update export status");
    console.error("Could not update export status");
  }
}

export async function fetchUserSettings(): Promise<UserModel> {
  const response: AxiosResponse<any> = await axios.get(`/api/users/settings`);
  const data = response.data;

  return {
    userName: data.userName,
    isAdminUser: data.isAdminUser,
    marketAreas: data.marketAreas,
  };
}

export const useGetUserGroupInformation = () => {
  const user = userStore.getState().user;
  return useQuery<UserModel, AxiosError>({
    queryKey: ["user", "settings"],
    queryFn: fetchUserSettings,
    enabled: !user?.userName,
    // initialData: existingUser ?? undefined,
    retry: (failureCount, error) => {
      const status = error?.response?.status;
      if (status === 503) return failureCount < 5;
      return failureCount < 3;
    },
    retryDelay: (attempt) => Math.min(30_000, 1000 * 2 ** attempt),
    refetchOnWindowFocus: false,
  });
};

export async function fetchAdvancedSearchResults(
  query: Models.AdvancedSearchApiPayload
): Promise<any> {
  const { setAdvancedSearchLoading } = useSearchStore.getState();
  try {
    if (query.showLoading) {
      setAdvancedSearchLoading(true);
    }
    const response: AxiosResponse = await axios.post(
      `/api/search/advanced`,
      query
    );
    if (query.showLoading) {
      setAdvancedSearchLoading(false);
    }
    return response.data;
  } catch (e) {
    if (query.showLoading) {
      setAdvancedSearchLoading(false);
    }
    toast.error("Error when doing advanced search");
    console.error("Error when doing advanced search", e);
  }
}

export async function exportExcel(
  query: Models.AdvancedSearchApiPayload
): Promise<any> {
  try {
    const response: AxiosResponse = await axios.post(
      `/api/search/exportToExcel`,
      JSON.stringify(query),
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    return response.data;
  } catch (e) {
    useSearchStore.getState().setAdvancedSearchLoading(false);
    toast.error("Error when doing Excel export");
    console.error("Error when doing Excel export", e);
  }
}

export function exportToExcel(
  route: string,
  query: Models.PagedQuery,
  name: string
) {
  // return async (dispatch, getState): Promise<any> => {
  try {
    axios
      .post(route, JSON.stringify(query), {
        headers: { "Content-Type": "application/json" },
        responseType: "blob",
      })
      .then((response) => {
        handleExport(
          response.data,
          `${name}_${moment().format("MM_DD_YYYY_HH_mm")}.xlsx`
        );
      });
  } catch (e) {
    toast.error("Error when doing Excel export");
  }
}

// NOT USED ANYWHERE SO COMMENTED
// export function exportWord(query: Models.AdvancedSearchApiPayload): Function {
//   return async (dispatch, getState): Promise<any> => {
//     try {
//       axios
//         .post(`/api/search/exportToWord`, JSON.stringify(query), {
//           headers: { "Content-Type": "application/json" },
//           responseType: "blob",
//         })
//         .then((response) => {
//           handleExport(
//             response.data,
//             `IB-Export_${moment().format("MM_DD_YYYY_HH_mm")}.docx`
//           );
//         });
//     } catch (e) {
//       dispatch(SearchActions.setAdvancedSearchLoading(false));

//       const error: Models.ApplicationError = {
//         type: Models.ErrorTypes.Internal,
//         id: uuidv4(),
//         error: e.response ? e.response : e,
//         message: "Error when doing Word export",
//       };

//       dispatch(ErrorActions.addError(error));
//     }
//   };
// }

export async function fetchAdvancedSearchOptions(): Promise<any> {
  try {
    const response: AxiosResponse = await axios.get(`/api/search/settings`);
    return response.data;
  } catch (e) {
    toast.error("Error fetching search settings");
    console.error("Error fetching search settings");
  }
}

export const useFetchUserProfile = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: ["recentQueries"],
    queryFn: async () => {
      const response = await axios.get(`/api/userprofile`);
      return response.data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
  });
};

export function useGetSharedQueryAPI(enabled: boolean, id: string) {
  return useQuery({
    queryKey: ["getSharedQuery", id],
    queryFn: async () => {
      const response: AxiosResponse = await axios.get(
        `/api/Search/GetShareAdvanceSearchAsync?linkName=${id}`
      );
      return response.data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
  });
}

export const useDeleteQueryMutation = () => {
  return useMutation({
    mutationFn: async (queryId: string) => {
      const { data } = await axios.delete(`/api/userprofile/search/${queryId}`);
      return data;
    },
  });
};

export async function fetchSearchSuggestions(
  userInput: string
): Promise<Models.ISearchSuggestionResponse[]> {
  if (userInput !== "") {
    try {
      const encodedSearch: string = encodeURIComponent(userInput);
      const response: AxiosResponse = await axios.get(
        `/api/search/suggestions?id=${encodedSearch}`
      );
      if (response) return response.data;
    } catch (e) {
      toast.error("Error fetching search suggestions");
    }
  }
  return [];
  // };
}

// export function fetchSparePartsList(): Function {
//   return async (dispatch, getState): Promise<Models.ItemsApiSparePart[]> => {
//     try {
//       const response: AxiosResponse = await axios.get(`/api/items`);
//       const attributes: Models.ItemsApiSparePartResponse[] = response.data;
//       return attributes.map((a) => {
//         return _.assign({}, a, {
//           isSparePart: a.isSparePart ? "Yes" : "No",
//         });
//       });
//     } catch (e) {
//       const error: Models.ApplicationError = {
//         type: Models.ErrorTypes.External,
//         id: uuidv4(),
//         error: e.response ? e.response : e,
//         message: "Error fetching spare parts",
//       };

//       dispatch(ErrorActions.addError(error));
//     }
//   };
// }

export const downloadExportedFile = async (fileId: string) => {
  try {
    const headers: any = { "Content-Type": "application/json" };
    const response = await axios.get(`/api/search/download/${fileId}`, {
      headers: headers,
      responseType: "blob",
    });
    handleExport(response.data, `${fileId}.xlsx`);
  } catch (e) {
    toast.error("Error when downloading file");
    console.error(e);
  }
};

export function downloadDocumentsEntityDocument(
  link: Models.Link,
  documentId: string
): any {
  try {
    const fileName = link.description;

    var headers: any = {
      "Content-Type": "application/json",
      "x-ot-documentId": documentId,
    };
    axios
      .get(link.url, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        handleExport(response.data, fileName);
      })
      .catch((e) => {
        toast.error("Error when downloading file");
      });
  } catch (e) {
    toast.error("Error when downloading file");
  }
}
export function useShareQueryMutation() {
  return useMutation({
    mutationFn: async (query: Models.UserSearch) => {
      const response: AxiosResponse = await axios.post(
        `/api/Search/ShareAdvanceSearchAsync`,
        query
      );
      return response.data;
    },
  });
}

export function saveUserSearchQuery() {
  return useMutation({
    mutationFn: async (query: Models.UserSearch) => {
      const response: AxiosResponse = await axios.post(
        `/api/userprofile/search`,
        query
      );
      return response.data;
    },
  });
}

// NO API PRESENT FOR SAVING HIDDEN FILTERS AS OF NOW SO COMMENTING BELOW CODE, CAN BE USED LATER IF API IS CREATED
// export async function saveHiddenFilters(hiddenFilters: string[]): Promise<any> {
//   try {
//     const response: AxiosResponse = await axios.post(
//       `/api/userprofile/hideFilters`,
//       hiddenFilters
//     );
//     return response.data;
//   } catch (e) {
//     const error: Models.ApplicationError = {
//       type: Models.ErrorTypes.Internal,
//       id: uuidv4(),
//       error: e.response ? e.response : e,
//       message: "Error saving hidden search filters",
//     };
//   }
// }

function handleExport(response: any, fileName: string): void {
  let a: any;

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    const fileData: any = [response];
    const blobObject: any = new Blob(fileData);
    window.navigator.msSaveOrOpenBlob(blobObject, fileName);
  } else {
    a = document.createElement("a");
    a.href = window.URL.createObjectURL(response);
    a.download = fileName;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}

export function useGetPowerBiEmbedCode(reportId: string) {
  return useQuery<Models.PowerBiReportPayload>({
    queryKey: ["powerBiEmbedCode"],
    queryFn: async () => {
      // if (process.env.NODE_ENV.toLocaleLowerCase() === "emulator") return null;
      const response: AxiosResponse = await axios.get(
        `/api/powerbi/${reportId}`
      );
      return response.data;
    },
    enabled: process.env.ASPNETCORE_ENVIRONMENT.toLowerCase() === "production", //powerbi report is disabled for dev and QA
    retry: false,
    refetchOnWindowFocus: false,
  });
}
// unused API call
// export function getPowerBiEmbedCode(reportId: string): Function {
//   return async (dispatch, getState): Promise<Models.PowerBiReportPayload> => {
//     try {
//       const state: Models.StateRoot = getState();

//       let settings: Models.AppSettings = Selectors.getSettings(state);
//       if (settings.environment.toLocaleLowerCase() === "emulator") {
//         return null;
//       }

//       if (!reportId) {
//         return null;
//       }

//       const response: AxiosResponse = await axios.get(
//         `/api/powerbi/${reportId}`
//       );
//       const report: Models.PowerBiReportPayload = response.data;
//       dispatch(SettingsActions.setPowerBiEmbedReport(report));
//       return report;
//     } catch (e) {
//       /* */
//     }
//   };
// }

export function useSendNewAssetRequest() {
  return useMutation({
    mutationFn: (requestData: Models.NewAssetRequest): Promise<boolean> => {
      return axios
        .post("/api/assets/", requestData)
        .then((response) => response.status === 200);
    },
  });
}

export const useGetModelRevisions = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: ["modelRevisions"],
    queryFn: async () => {
      const response = await axios.get("/api/modelrevisions");
      return response.data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
  });
};

export const useGetSellableProductModels = ({
  enabled,
}: {
  enabled: boolean;
}) => {
  return useQuery({
    queryKey: ["sellableProductModels"],
    queryFn: async () => {
      const response = await axios.get("/api/sellableproductmodels");
      return response.data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
  });
};

export const useGetSiteIds = (userInput: string, enabled) => {
  return useQuery({
    queryKey: ["siteIds", userInput],
    queryFn: async () => {
      const encodedSearch: string = encodeURIComponent(userInput);
      const response = await axios.get(`/api/sites/GetSites/${encodedSearch}`);
      return response.data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
    staleTime: 5 * 60 * 1000,
  });
};

export const useGetProjectIds = (userInput: string, enabled) => {
  return useQuery({
    queryKey: ["ProjectIds", userInput],
    queryFn: async () => {
      const encodedSearch: string = encodeURIComponent(userInput);
      const response = await axios.get(
        `/api/Project/GetProjects/${encodedSearch}`
      );
      return response.data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
    staleTime: 5 * 60 * 1000,
  });
};

const deleteAssetAsync = async ({
  assetId,
  requestData,
}: {
  assetId: string;
  requestData: Models.DeleteAssetRequest;
}): Promise<boolean> => {
  const response = await axios.delete(`/api/assets/${assetId}`, {
    data: requestData,
  });
  return response.status === 200;
};

export function useDeleteAssetMutation() {
  return useMutation<
    boolean,
    Error,
    {
      assetId: string;
      requestData: Models.DeleteAssetRequest;
    }
  >({ mutationFn: deleteAssetAsync });
}
export const useGetAssetBasicData = (assetId: string) => {
  return useQuery<Models.AssetBasicDataModel, Error>({
    queryKey: ["assetBasicData", assetId],
    queryFn: async () => {
      const response = await axios.get(`/api/assets/${assetId}/basicdata`);
      return response.data;
    },
    enabled: !!assetId,
    retry: false,
  });
};

const fetchChangeRequests = async (): Promise<Models.ChangeRequest[]> => {
  const res = await axios.get<Models.ChangeRequest[]>("/api/changeRequests");
  return res.data;
};

export function useChangeRequests(
  options?: Partial<UseQueryOptions<Models.ChangeRequest[], AxiosError>>
) {
  return useQuery<Models.ChangeRequest[], AxiosError>({
    queryKey: ["changeRequests"],
    queryFn: fetchChangeRequests,
    refetchOnWindowFocus: false,
    retry: 1,
    ...options,
  });
}

export function useEditAssetMutation() {
  return useMutation({
    mutationFn: async ({
      assetId,
      requestData,
    }: {
      assetId: string;
      requestData: Models.EditAssetRequest;
    }) => {
      const response = await axios.put(`/api/assets/${assetId}`, requestData);
      if (response.status !== 200) {
        throw new Error("Failed to update asset");
      }
      return true;
    },
  });
}
export const useGetPendingChangeRequests = (url: string, detailId: string) => {
  //to get change requests for one paricular site/asset
  return useQuery<Models.PendingChangeRequest[], Error>({
    queryKey: ["PendingChangeRequests", detailId],
    queryFn: async () => {
      const response = await axios.get(url);
      return response.data;
    },
    enabled: !!detailId,
    retry: false,
    refetchOnWindowFocus: false,
  });
};

export async function fetchPage(
  route: string,
  query: Models.PagedQuery
): Promise<Models.PagedQueryResponse> {
  try {
    const response: AxiosResponse = await axios.post(route, query);
    const data: Models.PagedQueryResponse = response.data;
    return data;
  } catch (e) {
    toast.error("Could not load data");
  }
}
const configuration = {
  headers: {
    accept: "application/json",
  },
  data: {},
};

export function searchAssetBySerialNumber(serialNumber: string) {
  return useQuery<Models.SerialNumberDto[]>({
    queryKey: ["searchAssetBySerialNumber", serialNumber],
    queryFn: async () => {
      const response = await axios.get(
        `/api/assets/serialnumber/${serialNumber}`
      );
      return response.data;
    },
    retry: false,
    enabled: false,
  });
}

export function useGetNotLinkedAssets(siteId: string) {
  return useQuery<Models.NotLinkedAssets[]>({
    queryKey: ["notLinkedAssets", siteId],
    queryFn: async () => {
      const response = await axios.get(
        `/api/Project/GetNotLinkedAssets/?siteId=${siteId}`
      );
      return response.data;
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
}

export function linkAssetToProjectMutation() {
  return useMutation({
    mutationFn: async ({
      assetIds,
      projectId,
    }: {
      assetIds: string[];
      projectId: string;
    }) => {
      const payload: Models.LinkAssetPayload = {
        projectId: projectId,
        Assets: assetIds,
      };
      const response = await axios.post(
        `/api/Project/MapAssetToProject`,
        payload
      );
      return response.data;
    },
  });
}

export function useSendDeleteDocumentRequest() {
  return useMutation({
    mutationFn: async ({
      siteId,
      fileName,
    }: {
      siteId: string;
      fileName: string;
    }) => {
      const response = await axios.delete(
        `/api/sites/${siteId}/documents/${fileName}`,
        configuration
      );
      return response.status == 200;
    },
  });
}

// export function sendDeleteDocumentRequest(
//   siteId: string,
//   fileName: string
// ): Function {
//   return async (dispatch, getState): Promise<boolean> => {
//     try {
//       const response = await axios.delete(
//         `/api/sites/${siteId}/documents/${fileName}`,
//         configuration
//       );
//       return response.status == 200;
//     } catch (e) {
//       const error: Models.ApplicationError = {
//         type: Models.ErrorTypes.Internal,
//         id: uuidv4(),
//         error: e.response ? e.response : e,
//         message: "Could not delete Document",
//       };

//       dispatch(ErrorActions.addError(error));
//       return false;
//     }
//   };
// }
//for Unlinking the asset from project
export function unlinkAssetMutation() {
  return useMutation({
    mutationFn: async ({
      assetId,
      projectId,
    }: {
      assetId: string;
      projectId: string;
    }) => {
      const response: AxiosResponse = await axios.get(
        `/api/Project/UnlinkAssetToProject?projectId=${projectId}&assetId=${assetId}`
      );
      if (response.status === 200) {
        return response.data;
      }
      throw new Error("Error in unlinking the asset");
    },
  });
}

//for Unlinking the asset from project
// export function unLinkAssetFromProject(
//   assetId: string,
//   projectId: string
// ): Function {
//   return async function (dispatch, getState): Promise<Models.UnlinkAsset> {
//     try {
//       const response: AxiosResponse = await axios.get(
//         `/api/Project/UnlinkAssetToProject?projectId=${projectId}&assetId=${assetId}`
//       );
//       if (response.status === 200) {
//         return response.data;
//       }
//       throw new Error("Error in unlinking the asset");
//     } catch (e) {
//       const error: Models.ApplicationError = {
//         type: Models.ErrorTypes.Internal,
//         id: uuidv4(),
//         error: e.response ? e.response : e,
//         message: `Could not unlink the asset ${assetId}`,
//       };

//       dispatch(ErrorActions.addError(error));
//     }
//   };
// }
